import React from 'react';

import useFilterAllowedQuestionType from 'hooks/useFilterAllowedQuestionType';
import { FormTypeKeys } from 'screens/MissionControl/Utilities/NewFormBuilderPage/utils';

import { PATIENT_FORM_TEMPLATE_QUESTION_TYPE } from '../../constants';
import FiltersSelectContent from '../FiltersSelectContent';

interface FilterPatientFormTemplateQuestionByTypeProps {
  type?: string;
  details?: {
    formType?: FormTypeKeys;
    formVersion?: string;
  };
}

const FilterPatientFormTemplateQuestionByType: React.FC<FilterPatientFormTemplateQuestionByTypeProps> = ({
  type = 'questionType',
  details,
}) => {
  const items = useFilterAllowedQuestionType<typeof PATIENT_FORM_TEMPLATE_QUESTION_TYPE[number]>({
    formType: details?.formType,
    formVersion: details?.formVersion,
    questions: PATIENT_FORM_TEMPLATE_QUESTION_TYPE,
  });

  return <FiltersSelectContent type={type} items={items} />;
};
export default FilterPatientFormTemplateQuestionByType;
